module.exports = __webpack_public_path__ + "assets/img/thumb-CMTP-Website.ac03272f.jpg";